import React, { useEffect, useState } from 'react';
import { X, Clock } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useOrganization } from '../contexts/OrganizationContext';
import { getSubscriptionStatus } from '../services/ApiService';

export default function TrialBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { currentOrg, isBoardMember } = useOrganization();
  const navigate = useNavigate();
  const { orgId } = useParams<{ orgId: string }>();
  const [checkoutEnabled, setCheckoutEnabled] = useState(false);
  const isBoardMemberInTrial = isBoardMember && currentOrg?.subscriptionStatus === 'trial';

  useEffect(() => {
    if (!orgId || !isBoardMemberInTrial) return;
    let cancelled = false;
    getSubscriptionStatus(orgId)
      .then(status => { if (!cancelled) setCheckoutEnabled(status.checkoutEnabled); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [orgId, isBoardMemberInTrial]);

  if (dismissed) return null;
  if (!currentOrg) return null;
  if (currentOrg.subscriptionStatus !== 'trial') return null;

  const getDaysLeft = (): number => {
    if (!currentOrg.trialEndsAt) return 0;
    const diff = new Date(currentOrg.trialEndsAt).getTime() - Date.now();
    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  };

  const daysLeft = getDaysLeft();
  const isUrgent = daysLeft <= 14;

  return (
    <div className={`flex items-center gap-3 px-4 py-2.5 text-sm ${
      isUrgent
        ? 'bg-orange-50 border-b border-orange-200 text-orange-800'
        : 'bg-blue-50 border-b border-blue-200 text-blue-800'
    }`}>
      <Clock className="w-4 h-4 flex-shrink-0" />
      <span className="flex-1">
        <strong>{daysLeft} dagar</strong> kvar av er gratis provperiod.
        {isBoardMember && checkoutEnabled && (
          <button
            onClick={() => navigate(`/org/${orgId}/billing`)}
            className="ml-2 underline font-medium hover:no-underline"
          >
            Aktivera prenumeration
          </button>
        )}
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="p-0.5 rounded hover:bg-black/10 transition-colors"
        aria-label="Stäng"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
